import { render, staticRenderFns } from "./NavigationDetail.vue?vue&type=template&id=49a72ae2"
import script from "./NavigationDetail.vue?vue&type=script&lang=js"
export * from "./NavigationDetail.vue?vue&type=script&lang=js"
import style0 from "./NavigationDetail.vue?vue&type=style&index=0&id=49a72ae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports